import Index from './components/Index'

export default [
  {
    path: '/dashboard',
    name: 'dashboard-index',
    component: Index
  }
]
